module.exports = __webpack_public_path__ + "static/media/reward-wrk.5b1100de.png";